import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-63deff9e")

_pushScopeId("data-v-63deff9e")
const _hoisted_1 = {
  key: 0,
  class: "main__section file-manager"
}
const _hoisted_2 = { class: "view-card" }
const _hoisted_3 = { class: "view-card__header" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "view-card__header__top" }, [
  /*#__PURE__*/_createVNode("span", { class: "header-title -bold" }, " 첨부파일 ")
], -1)
const _hoisted_5 = { class: "view-card__header__mid" }
const _hoisted_6 = { class: "header-file" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  class: "file-image",
  src: "/images/new/file.svg"
}, null, -1)
const _hoisted_8 = { class: "file-info" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "-vector" }, null, -1)
const _hoisted_10 = { class: "view-card__body" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FileViewer = _resolveComponent("FileViewer")

  return (_openBlock(), _createBlock("main", null, [
    (!_ctx.state.isLoading)
      ? (_openBlock(), _createBlock("section", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode("div", _hoisted_8, [
                    _createVNode("span", null, _toDisplayString(_ctx.state.select.Title), 1),
                    _createVNode("span", null, _toDisplayString(_ctx.state.select.FileType), 1)
                  ])
                ])
              ])
            ]),
            _hoisted_9,
            _createVNode("div", _hoisted_10, [
              (_ctx.state.select)
                ? (_openBlock(), _createBlock(_component_FileViewer, {
                    key: 0,
                    select: _ctx.state.select,
                    isSidebar: false
                  }, null, 8, ["select"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})